.pan-zoom-wrapper {
  position: absolute;
  top: 57px; /* height of the modal header */
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 200px;
  z-index: 1;
  overflow: hidden;
}

.pan-zoom {
  width: 100%;
  height: 100%;
  position: relative;
}

.photo-img {
  width: auto;
  height: min(100%, 90vh);
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  display: block;
}

.photo-data {
  line-height: 1.5;
}

.photo-detail-text {
  position: absolute;
  bottom: 0;
  background-color: var(--background-color-step-50);
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease-in;
  z-index: 10;
}

@media (max-width: 575.98px) {
  .photo-detail-text {
    padding: 0.5rem; /* Reduced padding on mobile */
  }
}

.hidden {
  display: none;
}

.photo-counter-controls {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 0 0.25rem;
}

.sticky-bottom-right {
  position: sticky;
  bottom: 0;
  padding: 8px 12px;
  text-align: right;
  z-index: 10;
}
